import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

export const useDashboardUnsaved = createGlobalState({
  key: "dashboardEditState",
  storage: "local",
  defaultValue: false,
  scoped: true,
  type: io.boolean,
});
